// namespace Pacem {
import { Rect } from "./rect";
const DefaultImagingResizeOptions = {
    mode: 'stretch',
    align: 'center',
    valign: 'middle',
    quality: 1,
    type: 'image/jpeg'
};
export class Imaging {
    static async loadImage(url) {
        const response = await fetch(url);
        if (!response.ok) {
            return null;
        }
        const blob = await response.blob();
        return blob;
    }
    static async resizeImage(img, width, height, options) {
        if (width <= 0 || height <= 0 || isNaN(width) || isNaN(height)) {
            throw new Error('Invalid target size');
        }
        if (typeof img === 'string') {
            img = await Imaging.loadImage(img);
        }
        const el = await self.createImageBitmap(img);
        const origWidth = el.width, origHeight = el.height;
        const cnv = new OffscreenCanvas(origWidth, origHeight);
        const ctx = cnv.getContext('2d');
        ctx.imageSmoothingEnabled =
            ctx['mozImageSmoothingEnabled'] =
                ctx['oImageSmoothingEnabled'] =
                    ctx['webkitImageSmoothingEnabled'] =
                        true;
        const { quality, type, mode, align, valign, background } = Object.assign({}, DefaultImagingResizeOptions, options ?? {});
        const from = { width: origWidth, height: origHeight, x: 0, y: 0 }, to = { x: 0, y: 0, width, height };
        const transformMatrix = Rect.findTransform(from, to, mode, align, valign);
        cnv.width = width;
        cnv.height = height;
        if (background) {
            ctx.fillStyle = background;
            ctx.fillRect(0, 0, cnv.width, cnv.height);
        }
        ctx.setTransform(transformMatrix);
        ctx.drawImage(el, 0, 0);
        const retval = await cnv.convertToBlob({ quality, type });
        return retval;
    }
}
// }
